import React from 'react';

import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import VaRadioField from 'platform/forms-system/src/js/web-component-fields/VaRadioField';
import YesNoField from 'platform/forms-system/src/js/web-component-fields/YesNoField';

const conditionalRevealFieldPropTypes = {
  childrenProps: PropTypes.shape({
    formContext: PropTypes.shape({
      onError: PropTypes.func,
      submitted: PropTypes.bool,
    }),
    onChange: PropTypes.func.isRequired,
  }).isRequired,
  uiOptions: PropTypes.shape({
    conditionalRevealValues: PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string]),
    ),
  }),
};

const conditionalRevealFieldDefaultProps = {
  uiOptions: {},
};

export const selectErrorValidationFixEnabled = state =>
  state?.form?.data?.form214502NewFormFlow === true &&
  state?.form?.data?.form214502ErrorValidationFix === true;

export const getConditionalRevealChildrenProps = (
  childrenProps,
  uiOptions,
  errorValidationFixEnabled,
) => {
  if (!errorValidationFixEnabled) {
    return childrenProps;
  }

  const conditionalRevealValues = uiOptions?.conditionalRevealValues || [];
  return {
    ...childrenProps,
    onChange: value => {
      const revealsConditionalField = conditionalRevealValues.includes(value);

      if (revealsConditionalField && childrenProps.formContext?.submitted) {
        childrenProps.formContext.onError?.(false);
      }

      childrenProps.onChange(value);
    },
  };
};

export function ConditionalRevealYesNoField(props) {
  const errorValidationFixEnabled = useSelector(
    selectErrorValidationFixEnabled,
  );
  return (
    <YesNoField
      {...props}
      childrenProps={getConditionalRevealChildrenProps(
        props.childrenProps,
        props.uiOptions,
        errorValidationFixEnabled,
      )}
    />
  );
}

ConditionalRevealYesNoField.propTypes = conditionalRevealFieldPropTypes;
ConditionalRevealYesNoField.defaultProps = conditionalRevealFieldDefaultProps;

export default function ConditionalRevealRadioField(props) {
  const errorValidationFixEnabled = useSelector(
    selectErrorValidationFixEnabled,
  );
  return (
    <VaRadioField
      {...props}
      childrenProps={getConditionalRevealChildrenProps(
        props.childrenProps,
        props.uiOptions,
        errorValidationFixEnabled,
      )}
    />
  );
}

ConditionalRevealRadioField.propTypes = conditionalRevealFieldPropTypes;
ConditionalRevealRadioField.defaultProps = conditionalRevealFieldDefaultProps;
